import { apiClient } from '@/lib/apiClient';

/**
 * Test function to verify API authentication and basic endpoints
 * This can be called from browser console for testing
 */
export async function testApiAuthentication() {
  
  try {
    // Test authentication
    // Authentication is handled automatically by apiClient
    const isAuth = await apiClient.isAuthenticated();
    if (isAuth) {
    } else {
    }
    
    // Test a simple GET endpoint
    const knowledge = await apiClient.get('/api/v1/ai/knowledge', { limit: 5 });
    
    // Test configuration endpoint
    const config = await apiClient.get('/api/v1/ai/config/sources');
    
    // Test costs endpoint
    const costs = await apiClient.get('/api/v1/ai/costs', { format: 'summary' });
    
    return true;
    
  } catch (error) {
    console.error('❌ API test failed:', error);
    return false;
  }
}

/**
 * Test function specifically for knowledge base operations
 */
export async function testKnowledgeBaseAPI() {
  
  try {
    // Test getting documents
    const docs = await apiClient.get('/api/v1/ai/knowledge', { source_type: 'app_faq' });
    
    const salesDocs = await apiClient.get('/api/v1/ai/knowledge', { source_type: 'sales_training' });
    
    const customDocs = await apiClient.get('/api/v1/ai/knowledge', { source_type: 'custom_docs' });
    
    return true;
  } catch (error) {
    console.error('Knowledge base test failed:', error);
    return false;
  }
}

// Make functions available globally for testing
if (typeof window !== 'undefined') {
  (window as any).testApiAuth = testApiAuthentication;
  (window as any).testKnowledgeAPI = testKnowledgeBaseAPI;
}